export default __webpack_public_path__ + "static/media/materialize-10.872ddd57.jpg";